import React, { InputHTMLAttributes, useState } from 'react';
import MaskedInput from 'react-text-mask';
import { InputContainer } from './styles';
export interface InputColorPicker extends InputHTMLAttributes<HTMLInputElement> {
  label?: string,
  value?: string,
  marginBotton?: string,
  name: string,
  block?: boolean,
  error?: boolean,
  errorMessage?: string,
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

export const InputColorPicker: React.FC<InputColorPicker> = ({
  name,
  label = "Meu input",
  value,
  marginBotton = "40",
  block = false,
  error = false,
  errorMessage,
  onChange,
  ...rest
}) => {
  // const [color, setColor] = useState(value);

  const onColorChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const color = event.target.value;
    // setColor(color);
    onChange(event);
  }

  return (
    <InputContainer
      block={block}
      marginBotton={marginBotton}
      hasError={error}
    >
      <div className="formField-input">
        <input
          name={name}
          type="color"
          className="input-color-picker"
          value={value}
          onChange={onColorChange}
        />
        <MaskedInput
          mask={['#', /[a-fA-F0-9]/, /[a-fA-F0-9]/, /[a-fA-F0-9]/, /[a-fA-F0-9]/, /[a-fA-F0-9]/, /[a-fA-F0-9]/]} 
          name={name}
          type="text" 
          className="input-color-text"        
          value={value}
          
          onChange={onColorChange} 
          {...rest}
        />
        <label htmlFor={name}>{label}</label>
      </div>
      {error ? <span className="error">{errorMessage}</span> : null}
    </InputContainer>
  )
}